import React, { useState, useContext, createContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import apiFetech from "../configs/axios";

// ** Utils Imports
import { getDefaultLanguage } from "../utils";

const languageContext = createContext();

export function ProviderLanguage({ children }) {
  const language = useProviderLanguage();
  return (
    <languageContext.Provider value={language}>
      {children}
    </languageContext.Provider>
  );
}

/**
 * Hook for child components to get the Language object ...
 * ... and re-render when it changes.
 * const {language,dir} = useLanguage()
 */
export const useLanguage = () => {
  return useContext(languageContext);
};

// Provider hook that creates language object and handles state
function useProviderLanguage() {
  const { lang, direction } = getDefaultLanguage();
  // ** State
  const [language, setLanguage] = useState(() => lang);
  const [dir, setDir] = useState(() => direction);
  const { i18n } = useTranslation();

  const changeLangage = (langData) => {
    if (langData !== lang) {
      i18n.changeLanguage(langData);
      const langAdd = langData.toUpperCase();
      if (langAdd.includes("AR")) {
        setDir("rtl");
      } else {
        setDir("ltr");
      }
      window.localStorage.setItem("lang", langData);
      setLanguage(langData);
    }
  };

  useEffect(() => {
    // ** Directions
    const directions = ["ltr-support", "rtl-support"];
    const htmlRoot = document.querySelector("html");
    const bodyTag = document.querySelector("body");
    htmlRoot.setAttribute("dir", `${dir}`);
    htmlRoot.setAttribute("lang", `${language}`);
    bodyTag.classList.remove(...directions);
    bodyTag.classList.add([`${dir}-support`]);
  }, [dir, language]);

  // ** API Add Headers Language
  useEffect(() => {
    // Add a request interceptor
    apiFetech.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        config.headers.common['X-localization'] = language;
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    return () => {};
  }, [language]);

  // Return State && SetState
  return {
    language,
    setLanguage,
    changeLangage,
    dir,
    setDir
  };
}
